import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';

function RecuperarSenha() {
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setErro('');
    setSucesso('');
    setIsLoading(true);
    try {
      const response = await axios.post(API_BASE_URL.FORGOT_PASSWORD, { email });
      setSucesso(response.data?.mensagem || 'Se o email estiver cadastrado, você receberá um link para redefinir sua senha.');
    } catch (error) {
      setErro(error.response?.data?.message || 'Não foi possível solicitar a recuperação. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url('/assets/login.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.55)' }} />

      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: '420px',
          margin: '1rem',
          borderRadius: '24px',
          overflow: 'hidden',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
      >
        <div style={{ background: 'linear-gradient(135deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)', padding: '1.25rem 2rem 1rem', textAlign: 'center' }}>
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="64"
            height="64"
            style={{ borderRadius: '12px', marginBottom: '0.75rem' }}
          />
          <h4 style={{ color: '#fff', margin: 0, fontWeight: 700, letterSpacing: '0.5px' }}>
            Recuperar senha
          </h4>
        </div>

        <div style={{ padding: '1.5rem 2rem 1rem' }}>
          <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '1.25rem', textAlign: 'center' }}>
            Informe seu email e enviaremos um link para redefinir sua senha.
          </p>
          <p style={{ fontSize: '0.78rem', color: '#6c757d', marginBottom: '1.25rem', textAlign: 'center' }}>
            Se você não receber o e-mail em alguns minutos, entre em contato com o administrador do sistema para redefinir sua senha.
          </p>

          {erro && (
            <div className="alert alert-danger d-flex align-items-start gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.83rem', borderRadius: '8px' }}>
              <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
              <span>{erro}</span>
            </div>
          )}
          {sucesso && (
            <div className="alert alert-success d-flex align-items-start gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.83rem', borderRadius: '8px' }}>
              <i className="bi bi-check-circle-fill flex-shrink-0 mt-1"></i>
              <span>{sucesso}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-3">
              <label style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem', display: 'block', letterSpacing: '0.5px' }}>
                <i className="bi bi-envelope me-2"></i>EMAIL
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Digite seu email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={isLoading || sucesso !== ''}
                style={{ borderRadius: '8px', padding: '0.6rem 0.9rem' }}
              />
            </div>

            <button
              type="submit"
              className="btn btn-success w-100"
              disabled={isLoading || sucesso !== ''}
              style={{ borderRadius: '8px', padding: '0.6rem', fontWeight: 600 }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Enviando...
                </>
              ) : (
                <>
                  <i className="bi bi-send me-2"></i>Enviar link de recuperação
                </>
              )}
            </button>
          </form>

          <div style={{ marginTop: '1rem', textAlign: 'center' }}>
            <button type="button" className="btn btn-link" onClick={() => navigate('/')}>
              Voltar para o login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecuperarSenha;
